module.exports = __webpack_public_path__ + "img/icon-partnership2.3f098e55.svg";